import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6ef69d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "rule" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colorred" }, "+2", -1 /* HOISTED */))
const _hoisted_4 = { class: "colorred" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colorred" }, "+2", -1 /* HOISTED */))
const _hoisted_6 = { class: "colorred" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colorred" }, "+2", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colorred" }, "+10", -1 /* HOISTED */))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.jfgz'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('me.textnone')), 1 /* TEXT */),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('me.mrqd1')), 1 /* TEXT */),
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('me.mrqd2')), 1 /* TEXT */)
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('me.zbgphd')), 1 /* TEXT */),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('me.zbgphd2')), 1 /* TEXT */)
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('me.text3')), 1 /* TEXT */),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */)
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('me.text4')) + " ", 1 /* TEXT */),
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('me.jf')) + _toDisplayString(_ctx.$t('me.mtsc')), 1 /* TEXT */)
      ]),
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('me.aboutjfsc')), 1 /* TEXT */),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('me.smjfsc')), 1 /* TEXT */),
      (!$setup.is_lb)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('me.text1')), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t('me.text1_2')), 1 /* TEXT */)),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('me.text2')), 1 /* TEXT */),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('me.jfdhjp')), 1 /* TEXT */),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('me.textp4')), 1 /* TEXT */)
    ])
  ]))
}